<template>
  <v-app>
    <sidebar/>
    <navbar/>
    <v-content>
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
      <v-snackbar
        v-model="_messageBar"
        :color="_messageType"
      >
        {{ _messageText }}
        <v-btn
          icon
          @click="_messageBar = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import Sidebar from './Sidebar'
import Navbar from './Navbar'

export default {
  name: 'tradle',

  components: {
    Sidebar,
    Navbar
  },

  data () {
    return {
      snackbar: true,
      text: 'hello'
    }
  },
  computed: {
    ...mapFields('tradle', {
      _messageBar: 'messageBar',
      _messageText: 'messageText',
      _messageType: 'messageType'
    })
  },
  methods: {}
}
</script>

<style scoped>
  .page-enter-active, .page-leave-active {
    transition: opacity 0.2s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
  }

  .wrapper {
    display: flex;
    height: 100%;
  }
</style>
